//

// vendor modules
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"

// shared modules
import {
    configureFlvSliceWithFilters,
    registerFilterableListView,
    registerFlvDataType,
    unregisterFilterableListView,
    registerPermanentFilters,
    applyDefaultSearchFilters,
    storeProcessedDefaultFilters,
    registerSerializationFunctions,
    applyInitialFilters,
} from "shared/search/action-creators"
import { applySearchifyInitialFilters, pushSearchifyLabel } from "shared/search/searchify/action-creators"
import { selectSearchIsTableView } from "shared/userdata/userdata-selectors"

// web only
import {
    applyFiltersFromURL,
    modifySearchQueryURL,
    setSearchBarData,
} from "app/static/frontend/search-new/action-creators"

import * as sharedSelectors from "shared/search/selectors"
import * as bulkActionsSelectors from "shared/search/searchify/bulkactions/selectors"
import * as searchifySelectors from "shared/search/searchify/selectors"
import { selectAllCustomFields } from "shared/customFields/selectors"
import { selectActionCentersList } from "shared/grassroots/selectors"
import { selectAlignmentTypes } from "shared/stakeholder/selectors"
import { selectHasMultipleBankAccounts, selectLedgerSettingsListIds } from "shared/pac/selectors"

// internal modules
import FilterableListView from "shared/search/components/FilterableListView/index"

const mapStateToProps = (state, props) =>
    createStructuredSelector({
        isRegisteredFlv: sharedSelectors.selectIsFlvSliceRegistered,
        hasRegisteredFilters: sharedSelectors.selectHasRegisteredFilters,
        isBulkActions: bulkActionsSelectors.selectIsBulkActionsSubmittable,
        isSearchify: searchifySelectors.selectIsSearchifySubmittable,
        searchPreloadDataLoaded: sharedSelectors.selectSearchPreloadDataLoaded,
        customFields: selectAllCustomFields,
        shouldDisableDefaultFilters: sharedSelectors.selectShouldDisableDefaultFilters,
        flvResource: sharedSelectors.selectFlvResource,
        searchTerm: sharedSelectors.selectSearchTerm,
        // for renderFooter() in app/static/frontend/search-new/components/FilterableListView/index
        currentPage: sharedSelectors.selectCurrentPage,
        currentCount: sharedSelectors.selectCurrentCount,
        currentData: sharedSelectors.selectCurrentData,
        isLoadingMore: sharedSelectors.selectIsLoadingMoreData,
        hasMoreDataToLoad: sharedSelectors.selectHasMoreDataToLoad,
        actionCentersList: selectActionCentersList,
        alignmentTypes: selectAlignmentTypes,
        ledgerSettingsListIds: selectLedgerSettingsListIds,
        isTableView: selectSearchIsTableView,
        hasMultipleBankAccounts: selectHasMultipleBankAccounts,
        tableId: sharedSelectors.selectUniqueFlvId,
    })

const mapDispatchToProps = {
    applyDefaultSearchFilters,
    applyFiltersFromURL,
    applyInitialFilters,
    applySearchifyInitialFilters,
    configureFlvSliceWithFilters,
    modifySearchQueryURL,
    pushSearchifyLabel,
    registerFilterableListView,
    registerFlvDataType,
    registerPermanentFilters,
    registerSerializationFunctions,
    setSearchBarData,
    storeProcessedDefaultFilters,
    unregisterFilterableListView,
}

export default connect(mapStateToProps, mapDispatchToProps)(FilterableListView)
